// material-ui
import {
    IconButton,
    Tooltip
} from '@mui/material';

// project imports
import useAPI from 'hooks/useAPI';
import TimesheetService from 'services/TimesheetService';
import ProjectAndTaskService from 'services/ProjectAndTaskService';
import { addTimeEntry, getCurrentTask } from 'store/slices/timesheet';

// assets
import PunchClockIcon from '@mui/icons-material/PunchClock';

// third-party
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'store';


const StartTimer = () => {

    const dispatch = useDispatch();
    const company_uuid = useSelector((state) => state.user.profile.companyUUID);
    const employee_uuid = useSelector((state) => state.user.profile.employeeUUID);
    const projects = useSelector((state) => state.timesheet.projects);

    const startTime = () => {
        listTasks.execute(company_uuid, projects[0].uuid);
    };

    const handleSuccess = (response) => {
        dispatch(addTimeEntry(response.data));
        dispatch(getCurrentTask(response.data));
    };

    const handleTaskSuccess = (response) => {
        try {
            const payload = {
                type: 'time-entry',
                taskDate: format(new Date(), 'yyyy-MM-dd'),
                projectUUID: response.data.items[0].project.uuid,
                taskUUID: response.data.items[0].uuid,
                description: '',
                empRemarks: '',
                startTime: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                timeentryOrigin: 'day'
            };
            addOtherTask.execute(company_uuid, employee_uuid, payload);
        } catch (error) {
            console.log(error);
        }
    };

    /* ---------- API's ---------- */

    const addOtherTask = useAPI(TimesheetService.addTask, handleSuccess, true);
    const listTasks = useAPI(ProjectAndTaskService.listTasks, handleTaskSuccess);

    return (
        <Tooltip title="Punch In">
            <IconButton size="small" onClick={startTime}>
                <PunchClockIcon fontSize="small" color="inherit" />
            </IconButton>
        </Tooltip>
    );
};

export default StartTimer;
